/* istanbul ignore file -- file not needed in testing coverage */
import { useEffect } from 'react';

let attrs;
try {
  // Use require here to avoid editor/TS issues with JSON imports in some setups.
  // eslint-disable-next-line global-require
  attrs = require('../generated/dynatraceAttrs.json');
} catch (e) {
  // eslint-disable-next-line no-console -- warning for missing generated runtime artifact
  console.warn(
    'Dynatrace attrs JSON not found at ../generated/dynatraceAttrs.json'
  );
  attrs = null;
}

const DynatracePlaceholder = () => {
  useEffect(() => {
    if (!attrs || !attrs.src) return;

    // Avoid duplicating the placeholder.
    if (document.querySelector('#dynatrace-agent-placeholder')) return;

    const script = document.createElement('script');
    script.type = 'text';
    script.id = 'dynatrace-agent-placeholder';
    script.setAttribute('src', attrs.src);
    if (attrs.integrity) script.setAttribute('integrity', attrs.integrity);
    if (attrs.crossorigin) {
      script.setAttribute('crossorigin', attrs.crossorigin);
    }
    if (attrs.dtconfig) script.setAttribute('data-dtconfig', attrs.dtconfig);

    document.head.appendChild(script);
  }, []);

  return null;
};

export default DynatracePlaceholder;
